import { useMutation } from "@apollo/client/react";
import { PREVIEW_MASK_AND_STAMP } from "../../mutations/invoiceInterpretationTemplates/previewMaskAndStamp";
import type { TemplateMaskInput, TemplateStampInput } from "../../../models/InvoiceInterpretationInputs";

type PreviewMaskAndStampResponseType = {
  invoiceInterpretation: {
    previewMaskAndStamp: {
      content: string;
      contentType: string | null;
      name: string;
    };
  };
};

export const usePreviewMaskAndStamp = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: PreviewMaskAndStampResponseType) => void;
  onError: (error: any) => void;
}) => {
  const [mutation, { loading, error, data }] = useMutation<PreviewMaskAndStampResponseType>(
    PREVIEW_MASK_AND_STAMP,
    { onCompleted, onError }
  );

  const previewMaskAndStamp = async ({
    templateId,
    clientIdentifier,
    maskInput,
    stampInput,
  }: {
    templateId?: string;
    clientIdentifier?: string;
    maskInput?: TemplateMaskInput[];
    stampInput?: TemplateStampInput | null;
  }) => {
    return mutation({
      variables: { templateId, clientIdentifier, maskInput, stampInput },
    });
  };

  return { previewMaskAndStamp, loading, error, data };
};
